import { ResizeOptions, ResizePosition } from "./types";
import {
  findEmptyOneByOnePositionsColumn,
  groupOneByOnePositions,
  widgetToOneByOnePositions,
} from "../../EmptyPositions/findEmptyPositions";

import { WidgetPos } from "../../types";
import { getHeightBounds } from "./getHeightBounds";
import { getWidthBounds } from "./getWidthBounds";

export function getResizePositions(
  widget: WidgetPos,
  column: WidgetPos[],
  possibleSizes: { w: number; h: number }[],
  numberOfRows: number = 4
): Record<ResizePosition, ResizeOptions> {
  "worklet";

  const eonebyone = findEmptyOneByOnePositionsColumn(
    column,
    widget.c,
    numberOfRows
  );
  const emptyPositions = groupOneByOnePositions(eonebyone).filter(
    (a) => a.length > 0
  );
  const oneByOne = widgetToOneByOnePositions(widget);

  const verticalCollapse =
    widget.w === 2 &&
    widget.h > 1 &&
    possibleSizes.filter(({ h }) => h < widget.h).length > 0;
  const horizontalCollapse =
    widget.h === 1 &&
    widget.w > 1 &&
    possibleSizes.filter(({ w }) => w < widget.w).length > 0;
  return {
    top: {
      expand:
        getHeightBounds(
          possibleSizes,
          widget.w,
          Math.floor(
            (emptyPositions.find((w) => w[w.length - 1] === oneByOne[0] - 1)
              ?.length ?? 0) / 2
          ) + widget.h
        ).max - widget.h,
      collapse: verticalCollapse,
    },
    bottom: {
      expand:
        getHeightBounds(
          possibleSizes,
          widget.w,
          Math.floor(
            (emptyPositions.find(
              (w) => w[0] === oneByOne[oneByOne.length - 1] + 1
            )?.length ?? 0) / 2
          ) + widget.h
        ).max - widget.h,
      collapse: verticalCollapse,
    },
    left: {
      expand:
        getWidthBounds(
          possibleSizes,
          widget.h,
          (widget.x % 2 === 1 &&
          emptyPositions.find((w) => w[w.length - 1] === oneByOne[0] - 1)
            ? 1
            : 0) + widget.w
        ).max - widget.w,
      collapse: horizontalCollapse,
    },
    right: {
      expand:
        getWidthBounds(
          possibleSizes,
          widget.h,
          (widget.x % 2 === 0 &&
          emptyPositions.find((w) => w[0] === oneByOne[oneByOne.length - 1] + 1)
            ? 1
            : 0) + widget.w
        ).max - widget.w,
      collapse: horizontalCollapse,
    },
  };
}
